export const plotOptions = {
    area: {
        stacking: 'normal',
        lineWidth: 1,
        marker: {
            symbol: 'circle'
        },
    },
    series: {
        fillColor: {
            linearGradient: [0, 0, 0, 100],
            stops: [
                [0, "#E6EAED"],
                [1, "#FFFFFF"]
            ]
        },
        marker: {
            enabled: false,
        },
    }
};

export const credits = {
    enabled: false,
};

export const responsiveOptions = {
    rules: [
        {
            condition: {
                maxWidth: 600,
            },
            chartOptions: {
                legend: {
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
                },
                yAxis: {
                    labels: {
                        align: 'left',
                        x: 0,
                        y: -5,
                    },
                    title: {
                        text: null,
                    },
                },
            },
        },
    ],
};